import { render, staticRenderFns } from "./AdminMessageCenter.vue?vue&type=template&id=be9f4638&scoped=true"
import script from "./AdminMessageCenter.vue?vue&type=script&lang=js"
export * from "./AdminMessageCenter.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/admin_message_center.css?vue&type=style&index=0&id=be9f4638&prod&scoped=true&lang=css&external"
import style1 from "./AdminMessageCenter.vue?vue&type=style&index=1&id=be9f4638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9f4638",
  null
  
)

export default component.exports